module.exports = __webpack_public_path__ + "img/avatar6.ad4a049c.png";